module.exports = __webpack_public_path__ + "img/Hub_logo_transparent.793c7357.png";